import React from "react";
import { DAY_ABBR, MOCK_RESOURCES, STATUS_CONFIG } from "./mockProjectData";

function fmt(date) {
    return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
}

const DAY_BADGE = {
    base: {
        fontSize: 10,
        fontWeight: 600,
        padding: "2px 6px",
        borderRadius: 4,
        background: "#e0e7ff",
        color: "#4f46e5",
        display: "inline-block",
    },
};

const SELECT_STYLE = {
    paddingLeft: 32,
    paddingRight: 28,
    paddingTop: 7,
    paddingBottom: 7,
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    fontSize: 12,
    color: "#334155",
    background: "#fff",
    cursor: "pointer",
    outline: "none",
    fontWeight: 500,
    appearance: "none",
    WebkitAppearance: "none",
};

const ProjectListView = ({
    resources,
    weekStart,
    onPrev,
    onNext,
    filterResource,
    onResourceChange,
}) => {
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 4);

    const uniqueNames = MOCK_RESOURCES.map((r) => r.name);
    const filtered = filterResource
        ? resources.filter((r) => r.name === filterResource)
        : resources;

    return (
        <div>
            {/* Title */}
            <h5 style={{ fontSize: 18, fontWeight: 800, color: "#1e293b", margin: "0 0 18px 0" }}>
                List View
            </h5>

            {/* Controls row */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 12,
                    background: "#fff",
                    borderRadius: 12,
                    padding: "14px 20px",
                    marginBottom: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                }}
            >
                {/* Date navigator */}
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <button
                        onClick={onPrev}
                        style={{ width: 28, height: 28, borderRadius: "50%", border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#475569", fontSize: 11 }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                    >
                        <i className="fa fa-chevron-left" />
                    </button>

                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <i className="fa fa-calendar" style={{ color: "#94a3b8", fontSize: 13 }} />
                        <span style={{ fontSize: 14, fontWeight: 600, color: "#334155", whiteSpace: "nowrap" }}>
                            {fmt(weekStart)} – {fmt(weekEnd)}
                        </span>
                    </div>

                    <button
                        onClick={onNext}
                        style={{ width: 28, height: 28, borderRadius: "50%", border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#475569", fontSize: 11 }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                    >
                        <i className="fa fa-chevron-right" />
                    </button>
                </div>

                {/* Resource filter */}
                <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                    <div style={{ position: "relative" }}>
                        <i
                            className="fa fa-user"
                            style={{
                                position: "absolute",
                                left: 10,
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#94a3b8",
                                fontSize: 11,
                                pointerEvents: "none",
                            }}
                        />
                        <select
                            value={filterResource}
                            onChange={(e) => onResourceChange(e.target.value)}
                            style={SELECT_STYLE}
                        >
                            <option value="">Select Resource</option>
                            {uniqueNames.map((n) => (
                                <option key={n} value={n}>{n}</option>
                            ))}
                        </select>
                        <i
                            className="fa fa-sliders"
                            style={{
                                position: "absolute",
                                right: 10,
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#94a3b8",
                                fontSize: 11,
                                pointerEvents: "none",
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Table */}
            <div style={{ display: "flex", alignItems: "stretch", gap: 0 }}>
                <div style={{
                    flex: 1, overflowX: "auto",
                    borderRadius: 12, border: "1px solid #e2e8f0",
                    background: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                }}>
                    <table className="table table-striped align-middle mb-0">
                        <thead>
                            <tr style={{ borderBottom: "2px solid #f1f5f9" }}>
                                {["Employee Name", "Job Title", "Department", "Days", "Task", "Status", "Actions"].map(
                                    (col) => (
                                        <th
                                            key={col}
                                            style={{
                                                padding: "10px 14px",
                                                textAlign: "left",
                                                fontSize: 12,
                                                fontWeight: 700,
                                                color: "#64748b",
                                                whiteSpace: "nowrap",
                                                background: "#fff",
                                                position: "sticky",
                                                top: 0,
                                            }}
                                        >
                                            {col}
                                        </th>
                                    )
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((r, idx) => (
                                <tr
                                    key={r.id}
                                    style={{
                                        borderBottom: "1px solid #f1f5f9",
                                        background: idx % 2 === 0 ? "#fff" : "#fafafa",
                                        transition: "background 0.12s",
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f8fafc")}
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.background = idx % 2 === 0 ? "#fff" : "#fafafa")
                                    }
                                >
                                    <td style={{ padding: "12px 14px", fontSize: 13, color: "#1e293b", fontWeight: 600 }}>
                                        {r.name}
                                    </td>
                                    <td style={{ padding: "12px 14px", fontSize: 13, color: "#475569" }}>
                                        {r.role}
                                    </td>
                                    <td style={{ padding: "12px 14px", fontSize: 13, color: "#475569" }}>
                                        {r.department}
                                    </td>
                                    <td style={{ padding: "12px 14px" }}>
                                        <div style={{ display: "flex", gap: 3, flexWrap: "nowrap" }}>
                                            {DAY_ABBR.map((d) => (
                                                <span key={d} style={DAY_BADGE.base}>{d}</span>
                                            ))}
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            padding: "12px 14px",
                                            fontSize: 12,
                                            color: "#64748b",
                                            maxWidth: 280,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                        title={r.task}
                                    >
                                        {r.task}
                                    </td>
                                    <td style={{ padding: "12px 14px" }}>
                                        {(() => {
                                            const cfg = STATUS_CONFIG[r.status] || STATUS_CONFIG["Available"];
                                            return (
                                                <span style={{
                                                    fontSize: 11,
                                                    fontWeight: 700,
                                                    padding: "3px 10px",
                                                    borderRadius: 12,
                                                    background: cfg.bg,
                                                    color: cfg.textColor,
                                                    letterSpacing: "0.04em",
                                                    whiteSpace: "nowrap",
                                                }}>
                                                    {cfg.label}
                                                </span>
                                            );
                                        })()}
                                    </td>
                                    <td style={{ padding: "12px 14px" }}>
                                        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                            <button
                                                title="Edit"
                                                style={{
                                                    border: "none",
                                                    background: "none",
                                                    cursor: "pointer",
                                                    color: "#6366f1",
                                                    fontSize: 15,
                                                    padding: 2,
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.color = "#4f46e5")}
                                                onMouseLeave={(e) => (e.currentTarget.style.color = "#6366f1")}
                                            >
                                                <i className="fa fa-pencil" />
                                            </button>
                                            <button
                                                title="Delete"
                                                style={{
                                                    border: "none",
                                                    background: "none",
                                                    cursor: "pointer",
                                                    color: "#ef4444",
                                                    fontSize: 15,
                                                    padding: 2,
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.color = "#dc2626")}
                                                onMouseLeave={(e) => (e.currentTarget.style.color = "#ef4444")}
                                            >
                                                <i className="fa fa-trash" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ProjectListView;
